//@ts-check

class LocalStorageService {
	constructor() {
		this.init();
	}

	init() {}

	/**
	 * Function saving items in the local storage
	 * @param {string} itemName The item name/key
	 * @param {any} itemValue The item value/content
	 */
	async save(itemName, itemValue) {


		var value = itemValue;
		if (typeof itemValue == 'object') {
			value = JSON.stringify(itemValue);
		}

		await localStorage.setItem(itemName, value);
	}

	/**
	 * Clears out the locally saved dates         * 
	 */
	clearSavedDates() {
		localStorage.setItem('selectedReportYear', '');
		localStorage.setItem('selectedReportMonth', '');
	}

	/**
	 * Function for retrieving items from local storage
	 * @param {string} itemName The item name/key
	 * @returns {any} The item
	 */
	retrieve(itemName) {
		var item = localStorage.getItem(itemName);

		if (item && ((item.indexOf('{') > -1 && item.indexOf('http') == -1) || item.indexOf('[') > -1)) {
			item = JSON.parse(item);
		}
		if (itemName === 'userProfile') {
			this.mapUser(item);
		}

		return item;
	}

	mapUser(user) {
		if (user && user.hasOwnProperty('WebUsername')) {
			user.UserName = user.WebUsername || user.UserName;
		}

		return user;
	}

	clear() {
		var itemsToBeCleared = [
			'lastLoggedIn',
			'mainProcessesDone',
			'selectedBuildingRef',
			'userProfile',
			'userSession',
			'resetPasswordToken',
			'isBusyLastShown',
			'clearanceCorrelationId',
			'rentalsCorrelationId',
			'auditsCorrelationId',
			'auditorsCorrelationId'
		];
		_.each(itemsToBeCleared, (itemName) => {
			this.delete(itemName);
		});
	}

	/**
	 * Function for clearing out all items from local storage
	 */
	clearAll() {
		localStorage.clear();
	}

    /**
	 * Function for clearing out all items from local storage
	 */
    clearPartial() {
        var itemsToBeCleared = [
            'lastLoggedIn',
            'mainProcessesDone',
            'selectedBuildingRef',
            'userProfile',
            'userSession',
            'isBusyLastShown',
            'clearanceCorrelationId',
			'rentalsCorrelationId',
			'auditsCorrelationId',
			'auditorsCorrelationId'

        ];
        _.each(itemsToBeCleared, (itemName) => {
            this.delete(itemName);
        });
    }

	/**
	 * Function for removing an item from local storage
	 * @param {string} name The name/key of the item in local storage to be removed
	 */
	delete(name) {
		localStorage.removeItem(name);
	}
}

export default /* @ngInject */ () => new LocalStorageService();
